import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generatePrompt } from '../utils/promptGenerator';
import { PromptData } from '../types';

export function ResultScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const promptData = location.state?.promptData as PromptData;
  const [copyStatus, setCopyStatus] = useState<'idle' | 'success' | 'error'>('idle');

  if (!promptData) {
    navigate('/');
    return null;
  }

  const generatedPrompt = generatePrompt(promptData);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(generatedPrompt);
      setCopyStatus('success');
      setTimeout(() => setCopyStatus('idle'), 2000);
    } catch (error) {
      console.error('Copy failed:', error);
      setCopyStatus('error');
      setTimeout(() => setCopyStatus('idle'), 2000);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-4">
      <div className="w-full max-w-3xl bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="bg-blue-50 p-4 rounded-full">
              <span className="text-4xl">✨</span>
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Your Generated Prompt
          </h1>
        </div>
        
        <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 rounded-xl p-6 mb-8 max-h-[60vh] overflow-y-auto shadow-lg">
          <pre className="whitespace-pre-wrap font-mono text-gray-800 text-lg">
            {generatedPrompt}
          </pre>
        </div>

        <div className="flex flex-col items-center gap-4">
          <button
            onClick={handleCopy}
            className={`
              w-full max-w-xs px-8 py-3 rounded-lg font-medium text-white transition-colors shadow-md
              ${copyStatus === 'success' 
                ? 'bg-green-500' 
                : copyStatus === 'error'
                ? 'bg-red-500'
                : 'bg-blue-600 hover:bg-blue-700'}
            `}
          >
            {copyStatus === 'success' ? '✓ Copied!' :
             copyStatus === 'error' ? '✗ Failed to Copy' :
             'Copy Prompt'}
          </button>

          <button
            onClick={() => navigate('/')}
            className="text-blue-600 hover:text-blue-700 font-medium"
          >
            Generate Another Prompt
          </button>
        </div>
      </div>
    </div>
  );
}